import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { config } from '#~/config/index.js';
import { isElectronApp } from '#~/electron/utils.js';
import { getActiveStudioId } from '#~/analytics/active-studio.js';
import { useLastRoomIdPref } from '#~/room/hook_last_id.js';
import { recordPlanPaymentReturn } from '#~/api/billing/payment-return.js';
import { usePlanPurchases } from '#~/api/billing/use-plan-purchase.js';

// The return route must run before Room can select the purchased Studio.
// Navigation carries purchase identity only; authenticated server reads
// decide payment and the current Studio keeps its own allowance generation.
export const BillingReturn = () => {
  const { roomId = '', mode, status = 'cancel' } = useParams();
  const [search] = useSearchParams();
  const sessionId = search.get('checkout_session_id') ?? '';
  const navigate = useNavigate();
  const [lastRoomId, , loaded] = useLastRoomIdPref();
  usePlanPurchases();
  useEffect(() => {
    if (loaded !== true) return;
    const vendor = config.vendor;
    if ((vendor !== 'iris' && vendor !== 'ptzoptics') || !/^[a-f0-9]{32}$/i.test(roomId)) {
      navigate('/', { replace: true });
      return;
    }
    if (mode === 'electron' && !isElectronApp()) {
      const product = vendor === 'iris' ? 'iris' : 'hive';
      const environment = config.env === 'prod' ? '' : config.env === 'stg' ? '-stg' : '-itg';
      const link = new URL(
        `${product}${environment}://billing/${roomId}/${status === 'success' ? 'success' : 'cancel'}`
      );
      if (/^cs_[a-zA-Z0-9_]+$/.test(sessionId))
        link.searchParams.set('checkout_session_id', sessionId);
      window.location.href = link.toString();
    } else {
      recordPlanPaymentReturn(vendor, roomId, sessionId);
    }
    const current = getActiveStudioId() ?? lastRoomId ?? roomId;
    navigate(`/room/${current}`, { replace: true });
  }, [roomId, mode, status, sessionId, loaded, lastRoomId, navigate]);
  return null;
};
